let UTILS = require("../libs/utils.js");
module.exports = {
  id: "race",
  name: "Race",
  alias: "race",
  sendR: 5,
  endStats: ["sid", "name", "score", "time"],
  gameTime: 0,
  showMS: true,
  timed: true,
  logTime: true,
  viewDis: 1000,
  noWeap: true,
  friendly: true,
  endSort: function (p9077, p9078) {
    if (p9077.score === p9078.score && p9077.gameTimer && p9078.gameTimer) {
      return p9077.gameTimer - p9078.gameTimer;
    } else {
      return p9078.score - p9077.score;
    }
  },
  gameStart: function (p9079) {
    p9079.lockMove();
    p9079.targetScore = 0;
    for (var vLN01179 = 0; vLN01179 < p9079.map.manager.objects.length; ++vLN01179) {
      if (p9079.map.manager.objects[vLN01179].score) {
        p9079.targetScore += p9079.map.manager.objects[vLN01179].scoreP;
      }
    }
  },
  condition: [function (game) {
    for (var vLN01180 = 0; vLN01180 < game.players.list.length; ++vLN01180) {
      if (game.players.list[vLN01180].score >= game.targetScore && !game.players.list[vLN01180].timer) {
        game.players.list[vLN01180].timer = game.lastTimer;
        game.players.list[vLN01180].gameTimer = game.gameTimer;
        if (!game.waitTimers) {
          game.waitTimers = [{
            time: 10000,
            contTime: true,
            msg: "race ends in ",
            trigger: function (p9081) {
              p9081.gameTimer = "skip";
            }
          }];
        }
      }
    }
    return true;
  }],
  waitTimers: [{
    time: 15000,
    msg: "race starting in ",
    trigger: function (p9082) {
      p9082.unlockMove();
    }
  }],
  custUI: function (p9083, p9084, p9085) {
    if (p9083.doLogTime && (weapHolder.style.display = "none", bottomRight.style.display = "none", speedRunHolder.style.display = "block", speedRunReset.style.display = p9083.mode && p9083.mode.allowReset ? "inline-block" : "none", p9085)) {
      var v7689;
      var vLS24 = "";
      for (var v7690 = p9083.map.manager.scorezones.length, vLN01181 = 0; vLN01181 < v7690; ++vLN01181) {
        v7689 = vLN01181 + 1;
        if (vLN01181 < p9084.maxSpdRChck) {
          vLS24 += "<div class='speedRunItem" + (vLN01181 == 0 ? " sriAct" : "") + "' id='spdRunI" + v7689 + "'>Point " + v7689 + "<span class='speedRunITim' id='spdRunIVal" + v7689 + "'>0:00</span></div>";
        }
      }
      if (vLS24 == "") {
        vLS24 = "<div>No Score Zones</div>";
      }
      speedRunList.innerHTML = vLS24;
      speedRunInfo.innerHTML = "Any% <span style='float:right;color:#fff'><span id='spdrnZC'  style='color:#fff'>0</span>/" + v7690 + "<i class='material-icons' style='color:#fff;font-size:30px;margin-left:10px'>flag</i></span>";
      speedRunTimer.innerHTML = "00:00.0";
    }
  }
};